import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import {
    fontColorSelector,
    fontFamilySelector,
    fontSizeSelector,
    lockAndMoreLayout,
    textAlignHSelector,
    textAlignVSelector
} from '../../canvas/properties/TextPropertyStripParts';
import { Text } from './Text';

export const textPropertyLayout = LockablePropertyStripLayout<Text>((d, s, o, w, a) => {
    return [
        // Text Settings
        ...fontColorSelector()(d, s, o, w, a),
        ...fontFamilySelector()(d, s, o, w, a),
        ...fontSizeSelector()(d, s, o, w, a),
        ...textAlignHSelector()(d, s, o, w, a),
        ...textAlignVSelector()(d, s, o, w, a),
        w.createButton({
            active: a.get('autoHeight'),
            image: 'deqo://icons/d2/text-wrap',
            text: 'Toggle Auto Height',
            onAction() {
                o.update(() => a.set('autoHeight', x => !x));
                this.update({ active: a.get('autoHeight') });
            }
        }),
        ...lockAndMoreLayout(d, s, o, w, a),
    ];
});
